var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.deliveryNoteOrders),function(order){return [_c('delivery-note-print',{key:order.id,attrs:{"order":order}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }